import { Box, BoxProps, Container, Flex, Image, Text } from '@chakra-ui/react';
import { CMS } from '@waitroom/models';
import { getRandomItem } from '@waitroom/utils';
import { ReactElement, useMemo } from 'react';
import { getImageUrl } from '../../../../cms/utils/base';
import { CDN_IMAGES_URL } from '../../../config';
import { isDarkColor } from '../../../utils';
import Carousel from '../../Carousel/Carousel';
import { blockquoteSx } from '../../Common/styles';

const Testimonials = ({
  items,
  bgColor,
  ...rest
}: CMS.Testimonials & BoxProps): ReactElement | null => {
  const itemsUi = useMemo(
    () =>
      items?.map((item, i) => (
        <Flex
          direction={['column', null, null, 'row']}
          mx={[0, 0, 0, -4, -8, -12]}
          w="100%"
          align="center"
          rowGap={12}
          columnGap={9}
          key={i}
        >
          <Flex direction="row" align="flex-start" order={[1, 0]} columnGap={6}>
            <Box as="blockquote" sx={blockquoteSx}>
              <Text fontSize={['lg', 'xl']} mb={8} whiteSpace="pre-line">
                {item.content}
              </Text>
              <footer>
                <Text as="cite" fontSize="lg" fontStyle="normal" fontWeight="bold">
                  {item.author}
                </Text>
                {item.authorAbout && (
                  <Text mt={2} noOfLines={2}>
                    {item.authorAbout}
                  </Text>
                )}
              </footer>
            </Box>
          </Flex>
          <Box order={[0, 1]} w="280px" flexShrink={0}>
            <Image
              src={getImageUrl(item.image?.asset?._ref, ['fit=crop', 'w=320', 'h=320'])}
              fallbackSrc={getRandomItem([
                `${CDN_IMAGES_URL}/fallback-2.png`,
                `${CDN_IMAGES_URL}/fallback-3.png`,
              ])}
              alt={item.author}
              mx="auto"
              rounded="xl"
            />
          </Box>
        </Flex>
      )),
    [items],
  );

  if (!items || !items.length) return null;
  return (
    <Box bgColor={bgColor} {...rest}>
      <Container maxW="1600px" overflow="visible" px={0}>
        <Carousel width="100%" interval={10000} loop>
          <Carousel.Items
            position="relative"
            columnGap={[20, 24, 32, 36, '25%']}
            px={[4, 4, 4, 8, 16, '18%']}
          >
            {itemsUi || []}
          </Carousel.Items>
          <Flex w="100%" justifyContent="center" mt={6}>
            {items.length > 1 ? (
              <Carousel.Navigation dark={bgColor && isDarkColor(String(bgColor))} />
            ) : null}
          </Flex>
        </Carousel>
      </Container>
    </Box>
  );
};
export default Testimonials;
